import React, { useState, useEffect } from "react";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import { Spin, DatePicker } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const { RangePicker } = DatePicker;

const JobStatus = () => {
  const [Jobs, setJobs] = useState([]);
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(29, "days"),
    dayjs(),
  ]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "SuperId",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "ProcessUrl",
      dataIndex: "ProcessUrl",
      render: (text) => (
        <span title={text}>
          {text?.length > 20 ? text.substring(0, 20) + "..." : text}
        </span>
      ),
      sorter: (a, b) => a.ProcessUrl.localeCompare(b.ProcessUrl),
    },

    {
      title: "RunTime",
      dataIndex: "TimeOutSec",
      sorter: (a, b) => (a?.TimeOutSec || 0) - (b?.TimeOutSec || 0),
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      render: (text) => (
        <span title={text}>
          {text?.length > 25 ? text.substring(0, 25) + "..." : text}
        </span>
      ),
    },
    {
      title: "DC Id",
      dataIndex: "DeviceId",
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      render: (value) => (
        <span
          style={{
            display: "inline-block",
            width: 15,
            height: 15,
            borderRadius: "50%",
            backgroundColor: value ? "#28a745" : "red",
          }}
        ></span>
      ),
      sorter: (a, b) => a.IsActive - b.IsActive,
    },
  ];

  const getjobsstatusbydate = async (start, end) => {
    if (!start || !end) return; // important fix

    setLoading(true);

    try {
      const FromDate = start.format("YYYY-MM-DD");
      const ToDate = end.format("YYYY-MM-DD");

      const response = await axios.get(
        `${API_BASE_URL}/api/getjobsstatus?FromDate=${FromDate}&ToDate=${ToDate}`
      );

      const data = response.data?.ResultData || [];
      setJobs(data);
    } catch (error) {
      console.error("Error fetching job status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) return;

    setDateRange(dates);
    getjobsstatusbydate(dates[0], dates[1]);
  };

  useEffect(() => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      getjobsstatusbydate(dateRange[0], dateRange[1]);
    }
  }, []);

  // const statusOptions = [
  //     { label: "All", value: null },
  //     { label: "Perennial code IT", value: 1 },
  //     { label: "Tata Group", value: 0 },
  // ];

  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Job Status</h4>
                <h6>Manage your Job Status</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
            </ul>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <h5 className="mb-3">Job Status List</h5>

              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="dropdown me-3">
                                    <Select
                                        classNamePrefix="react-select"
                                        placeholder="Select URL"
                                        // Find the matching option for display
                                        // value={statusOptions.find(option => option.value === selectedStatus) || null}
                                        // onChange={handleStatusChange}
                                        options={statusOptions}
                                        isClearable={true}
                                        styles={{ width: 180 }}
                                    />
                                </div>
                                <div className="dropdown me-3">
                                    <Select
                                        classNamePrefix="react-select"
                                        placeholder="Select  Job Status"
                                        // Find the matching option for display
                                        // value={statusOptions.find(option => option.value === selectedStatus) || null}
                                        // onChange={handleStatusChange}
                                        options={statusOptions}
                                        isClearable={true}
                                        styles={{ width: 180 }}
                                    />
                                </div> */}
                <div className="dropdown me-3">
                  <RangePicker
                    value={dateRange}
                    allowClear={false}
                    onChange={handleDateChange}
                    format="MM/DD/YYYY"
                    presets={[
                      {
                        label: "Today",
                        value: [dayjs(), dayjs()],
                      },
                      {
                        label: "This Week",
                        value: [dayjs().startOf("week"), dayjs()],
                      },
                      {
                        label: "This Month",
                        value: [dayjs().startOf("month"), dayjs()],
                      },
                    ]}
                  />

                  <span className="input-icon-addon">
                    <i className="ti ti-chevron-down" />
                  </span>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table columns={columns} dataSource={Jobs} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </>
  );
};

export default JobStatus;
